import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AiAgentChatStateService } from '../../../core/services/ai-agent-chat-state';

@Component({
  selector: 'app-ai-composer',
  standalone: false,
  templateUrl: './ai-composer.html',
  styleUrl: './ai-composer.scss',
})
export class AiComposer {
  @Input() message = '';
  @Input() placeholder = 'Ask the assistant';
  @Input() hint = '';
  @Input() mode: 'page' | 'popover' = 'page';
  @Input() busy = false;
  @Output() messageChange = new EventEmitter<string>();
  @Output() submitted = new EventEmitter<string>();

  constructor(public readonly state: AiAgentChatStateService) {}

  submit(): void {
    const content = this.message.trim();
    if (this.busy || !content) return;
    this.message = '';
    this.messageChange.emit('');
    this.submitted.emit(content);
  }

  updateMessage(value: string): void {
    this.message = value;
    this.messageChange.emit(value);
  }

  onKeydown(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    if (keyboardEvent.shiftKey) return;
    event.preventDefault();
    this.submit();
  }
}
